import * as React from 'react'
import {styled} from '@mui/material/styles'
import Button from '@mui/material/Button'
import { color } from 'framer-motion'

const CustomSecondaryButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 14,
  fontFamily: 'Inter, sans-serif',
  padding: '8px 15px',
  border: '1px solid',
  lineHeight: 1.5,
  backgroundColor: '#f6f6f6',
  borderColor: '#e2e2e2',
  borderRadius: '0',
  color: '#000',
  '&:hover': {
    backgroundColor: '#fafafa',
    //borderColor: '#E82347',
    boxShadow: 'none',
    //color: '#fff',
  },
  '&:active': {
    boxShadow: 'none',
    //backgroundColor: '#E84F6B',
    //borderColor: '#E84F6B',
  },
  '&:disabled': {
    boxShadow: 'none',    
    borderColor: '#cfcfcf',
  },
  
})

export default function WbSecondaryButton({CustomSecButtonText, onClick, ...props}) {
  return (
    <CustomSecondaryButton
      variant="contained"
      disableRipple
      onClick={onClick}
      {...props}
    >
      {CustomSecButtonText}
    </CustomSecondaryButton>
  )
}
